import Vue from 'vue'
import AsyncComputed from 'vue-async-computed'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import VueMarkdown from 'vue-markdown'

Vue.use(VueMarkdown);

/*eslint-disable */
//There's an annoying warning that clogs up the console when you use v-calendar, this suppresses it.
//https://github.com/vuetifyjs/vuetify/issues/9999
const ignoreWarnMessage = 'The .native modifier for v-on is only valid on components but it was used on <div>.';
Vue.config.warnHandler = function (msg, vm, trace) {
  // `trace` is the component hierarchy trace
  if (msg === ignoreWarnMessage) {
    msg = null;
    vm = null;
    trace = null;
  }
}
/*eslint-enable */

Vue.config.productionTip = false

Vue.use(AsyncComputed)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
